// extracted by mini-css-extract-plugin
module.exports = {"container":"navigation_container__klevE","sidebar":"navigation_sidebar__2NrMB","content":"navigation_content__1VRIn","open":"navigation_open__3g3EN"};